import { useRouter } from 'next/router';
import React from 'react';
import HotelSelector from '../../components/HotelSelector/HotelSelector';

export default function HotelSeletorPage() {
  const router = useRouter();

  switch (router.asPath) {
    case '/chain/hoteles-civitfun-dev':
    case '/chain/2345':
      router.push('https://www.civitfun.com/');
      break;
    default:
      break;
  }

  return <HotelSelector></HotelSelector>;
}
